import { render } from "./GameList.vue?vue&type=template&id=6e88b8ef&scoped=true"
import script from "./GameList.vue?vue&type=script&lang=js"
export * from "./GameList.vue?vue&type=script&lang=js"

import "./GameList.vue?vue&type=style&index=0&id=6e88b8ef&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e88b8ef"]])

export default __exports__